/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconFishHook = createReactComponent("outline", "fish-hook", "IconFishHook", [["path", { "d": "M16 9v6a5 5 0 0 1 -10 0v-4l3 3", "key": "svg-0" }], ["path", { "d": "M16 7m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", "key": "svg-1" }], ["path", { "d": "M16 5v-2", "key": "svg-2" }]]);

export { IconFishHook as default };
//# sourceMappingURL=IconFishHook.mjs.map
